import React, { useRef } from "react";
import { Outlet } from "react-router-dom";
import Header from "components/Header/Header.jsx";

const Layout = (props) => {
  const mainPanel = useRef();
  return (
    <div className="wrapper">
      <div className="main-panel" ref={mainPanel}>
        <Header mapVersion={true} />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
